import React from 'react';
import { User, Building2 } from 'lucide-react';

type Props = {
  guideName: string;
  organizerName: string;
};

export const GuideInfo = ({ guideName, organizerName }: Props) => {
  return (
    <td className="px-6 py-4">
      <div className="space-y-3">
        <div className="flex items-center gap-2">
          <User size={16} className="text-primary-500" />
          <span className="font-medium">{guideName}</span>
        </div>
        <div className="flex items-center gap-2">
          <Building2 size={16} className="text-gray-500" />
          <span className="text-sm text-gray-600">{organizerName}</span>
        </div>
      </div>
    </td>
  );
};